"use strict";
import { initTooltips } from './tooltip';

let biRestHeaders = function (url) {
  try {
    if (typeof window.biRestNonce !== 'undefined' && window.biRestNonce && typeof url === 'string' && url.indexOf('/wp-json/businessinfo/v1/') !== -1) {
      return { 'X-WP-Nonce': window.biRestNonce };
    }
  } catch (e) {}
  return {};
};

let biGetJSON = function (url, success, fail) {
  const headers = biRestHeaders(url);
  if (headers && Object.keys(headers).length) {
    return $.ajax({
      url: url,
      method: 'GET',
      dataType: 'json',
      headers: headers
    }).done(success).fail(fail);
  }
  return $.getJSON(url).done(success).fail(fail);
};

let biNormalizeRestHtmlResponse = function (result) {
  if (typeof result === 'string') {
    return result;
  }
  if (result && typeof result.html === 'string') {
    return result.html;
  }
  return '';
};

let biGetHTML = function (url, success, fail) {
  const headers = biRestHeaders(url);
  const isBiRestHtml =
    typeof url === 'string' && url.indexOf('/wp-json/businessinfo/v1/') !== -1;

  const wrapSuccess = function (result) {
    success(isBiRestHtml ? biNormalizeRestHtmlResponse(result) : result);
  };

  if (headers && Object.keys(headers).length) {
    return $.ajax({
      url: url,
      method: 'GET',
      dataType: isBiRestHtml ? 'json' : 'html',
      headers: headers
    })
      .done(wrapSuccess)
      .fail(fail);
  }

  if (isBiRestHtml) {
    return $.ajax({
      url: url,
      method: 'GET',
      dataType: 'json'
    })
      .done(wrapSuccess)
      .fail(fail);
  }

  return $.get(url).done(success).fail(fail);
};

/* vygeneruje HTML pro jednotlivé položky filtru <li> */
let renderFilter = function (response, refresh) {
  if (refresh) {
    $('.js-tbc-1-filter').html('');
  }

  //console.log(response.taxonomies);

  localStorage.removeItem('allFilterSearchTerms');
  localStorage.setItem('allFilterSearchTerms', JSON.stringify(response.taxonomies));
  //localStorage.setItem('allFilterSearchTerms', JSON.stringify(response));

  $.each(response.taxonomies, function (key, item) {
    let displayCategoryName = item.name === 'Druh akce' ? 'Typ akce' : item.name;
    let taxonomyRowTemp = $(`
      <li class="tbc-1-item filter--result-info__theme js-level_1" id="${item.taxonomy}" data-name="${item.name}" data-submenu="${item.terms && item.terms.length > 0 ? item.taxonomy + '_level_1' : ''}">
          <label class="tbc-1-item-name" data-theme="${item.taxonomy}" tabindex="0">
              ${displayCategoryName}
              ${item.terms && item.terms.length > 0 ? '<span class="tbc-1-icon-arrow"></span>' : ''}
          </label>
      </li>
    `);
    $('.js-tbc-1-filter').append(taxonomyRowTemp);
  });

  response.taxonomies.forEach(taxonomy => {
    processTermsToLocalStorage(taxonomy, taxonomy.terms);
  });
};

/* načte data pro filtr */
let loadFilter = function (refresh, query) {
  let filter = $('.filter');
  if (filter.length) {

    if (!query) {
      query = $.query.parseNew(location.search);
    }

    let url;
    if (typeof window.biRestFilterUrl !== 'undefined' && typeof window.biFilterContext !== 'undefined') {
      const search = location.search.replace(/^\?/, '');
      const sep = search ? '&' : '';
      const ctx = window.biFilterContext;
      url = window.biRestFilterUrl + '?' + search + sep + 'context=' + ctx.context + (ctx.vertical_id ? '&vertical_id=' + ctx.vertical_id : '');
    } else {
      query = query.set('ajax', 1).set('load', 'filter');
      url = query.toString();
    }

    // Kontrola, jestli URL není prázdná
    if (!url || url.trim() === '') {
      console.warn('loadFilter: Prázdný query string');
      return;
    }

    biGetJSON(url, function (response) {
        renderFilter(response, refresh);
      }, function (jqXHR, textStatus, errorThrown) {
        // Ignoruj chyby, pokud byl request zrušen (readyState: 0, status: 0)
        // To se často stává při navigaci nebo když se stránka rychle mění
        if (jqXHR.readyState === 0 && jqXHR.status === 0) {
          // Request byl zrušen před odesláním - není to skutečná chyba
          return;
        }

        // Loguj pouze skutečné chyby
        console.error('Chyba při načítání filtru:', {
          status: jqXHR.status,
          statusText: jqXHR.statusText,
          textStatus: textStatus,
          errorThrown: errorThrown,
          url: url
        });
      }).always(function () {
        // Loader se odstraní v renderFilter
        $('.js-filter-loader').remove();
      });
  }
};

/* načte data pro filtr - struktura vnoření nabídek */
function processTermsToLocalStorage(taxonomy, terms, parentSlug = '', level = 1) {
  if (!terms || !terms.length) return;

  let filterSearchTerms = JSON.parse(localStorage.getItem('allFilterSearchterms')) || [];

  let storageKey = parentSlug
    ? `${taxonomy.taxonomy}_${parentSlug}_level_${level}`
    : `${taxonomy.taxonomy}_level_${level}`;

  localStorage.removeItem(storageKey);

  // Vytvoření HTML pro aktuální úroveň
  const html = terms.map(term => `
        <li
          class="tbc-1-item js-item-checkbox filter--result-info__theme ${term.children && term.children.length > 0 ? `js-enter-level_${level + 1} js-space-level` : 'js-enter-level-none'}"
          id="${term.slug}" data-parent="${taxonomy.taxonomy}"
          tabindex="0"
          aria-label="${term.name}"
        >
            <input
              type="checkbox" class="tbc-1-checkbox js-filter-checkbox js-checkbox-level_${level + 1}"
              id="term-${term.id}"
              name="term-${term.slug}"
              data-term-id="${term.id}"
              data-term-slug="${term.slug}"
              data-parent="${parentSlug}"

            >
            <label
              for="term-${term.id}"
              class="tbc-1-item-name ${term.children && term.children.length > 0 ? `js-level_${level + 1}` : 'js-level-none'}"
              data-theme="${term.slug}"
              data-name="${term.name}"
              ${term.children && term.children.length > 0 ? `data-submenu="${taxonomy.taxonomy}_${term.slug}_level_${level + 1}"` : ''}
            >
              ${term.name}
              ${term.children && term.children.length > 0 ? '<span class="tbc-1-icon-arrow"></span>' : ''}
            </label>
        </li>
    `).join('');

  localStorage.setItem(storageKey, html);

  // Rekurzivní zpracování children
  terms.forEach(term => {
    if (term.children && term.children.length) {
      processTermsToLocalStorage(taxonomy, term.children, term.slug, level + 1);
    }
  });
}

//Zobrazení carouselů (video + audio)
let renderRelatedContent = function (response) {
  let mediaArr = Array.isArray(response?.audio_video) ? response.audio_video : [];
  let articlesArr = Array.isArray(response?.posts) ? response.posts : [];

  if (mediaArr.length == 0 && articlesArr.length == 0) {
    // Pravý sloupec u detailu organizace není „Doporučujeme“ — nesmí se použít full-width (schovalo by navigaci).
    if (!$('.article-right-column.organizace-right-column').length) {
      $('.article-content__wrapper').addClass('full-width');
    }
  }

  if (mediaArr.length > 0) {
    let videoContent = ''; // Proměnná pro videa
    let audioContent = ''; // Proměnná pro audia

    mediaArr.forEach((item) => {
      //videa
      if (item.iframe_video && item.iframe_video.trim() !== '') {
        let videoUrl = item.iframe_video;
        let hrefAttributes = window.cookieConsent && window.cookieConsent.allowedCategory('third_party') ?
          `href="${videoUrl}" data-type="iframe" data-iframeAttr="autoplay; fullscreen" data-fancybox="video"` :
          `href="${item.link}" target="_blank"`;

        videoContent += `
            <div class="right-col-slider-item">
              <a ${hrefAttributes}>
                <div class="image">
                  <img src="${item.thumbnail}" alt="${item.title}">
                </div>
                <div class="title">
                  ${item.short_name ? item.short_name : item.title}
                </div>
              </a>
            </div>`;
        //audia
      } else if (item.iframe_audio && item.iframe_audio.trim() !== '') {
        let audioUrl = item.iframe_audio;
        let hrefAttributes = '';
        //spotify + appple podcasts => iframe
        if (item.audio_platform === 'link_spotify' || item.audio_platform === 'link_apple_podcasts') {
          hrefAttributes = window.cookieConsent && window.cookieConsent.allowedCategory('third_party') ?
            `href="${audioUrl}" data-type="iframe" data-iframeAttr="autoplay; fullscreen" data-fancybox="audio"` :
            `href="${item.link}" target="_blank"`;
        } else {
          //bez iframu
          hrefAttributes = `href="${audioUrl}" target="_blank"`;
        }

        audioContent += `
            <div class="right-col-slider-item audio">
              <a ${hrefAttributes}>
                <div class="image">
                  <img src="${item.thumbnail}" alt="${item.title}">
                </div>
                <div class="title">
                  ${item.short_name ? item.short_name : item.title}
                </div>
              </a>
            </div>`;
      }
    });

    // Po smyčce přidáme obsah do DOM pouze pokud existuje
    //video
    if (videoContent) {
      $('.right-col-video-slider.video').append(videoContent);
    } else {
      $('.js-list-right-slider.video').hide();
      $('.js-article-right-slider.video').hide();
    }

    //audio
    if (audioContent) {
      $('.right-col-video-slider.audio').append(audioContent);
    } else {
      $('.js-list-right-slider.audio').hide();
      $('.js-article-right-slider.audio').hide();
    }

    // Přidání tříd podle podmínek
    if (videoContent && !audioContent) {
      $('.right-col-video-slider.video').addClass('lowest-slider'); // Pokud existuje jen video
    } else if (!videoContent && audioContent) {
      $('.right-col-video-slider.audio').addClass('lowest-slider'); // Pokud existuje jen audio
    } else if (videoContent && audioContent) {
      $('.right-col-video-slider.audio').addClass('lowest-slider'); // Pokud existují obě, přidáme jen audiu
      $('.right-col-video-slider.video, .right-col-video-slider.audio').addClass('available'); // Přidáme available oběma (kvůli návaznosti css - nadpisů carouselů)
    }

    //přidáme slider pro single post
    //video
    if (videoContent) {
      if ($('.js-article-right-slider.video').length) {
        $('.js-article-right-slider.video').slick({
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: false,
          slidesToShow: 1,
          slidetToScroll: 1,
          autoplaySpeed: 5000,
          responsive: [{
              breakpoint: 1050,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 799,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
      }
    }

    //pro single post
    //audio
    if (audioContent) {
      if ($('.js-article-right-slider.audio').length) {
        $('.js-article-right-slider.audio').slick({
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: false,
          slidesToShow: 1,
          autoplaySpeed: 8000,
          slidetToScroll: 1,
          responsive: [{
              breakpoint: 1050,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 799,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
      }
    }


    //pro rubriky
    //video
    if (videoContent) {
      if ($('.js-list-right-slider.video').length) {
        $('.js-list-right-slider.video').slick({
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: false,
          slidesToShow: 1,
          slidetToScroll: 1,
          autoplaySpeed: 5000,
          responsive: [{
              breakpoint: 1000,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 799,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
      }

    }
    //audio
    if (audioContent) {
      if ($('.js-list-right-slider.audio').length) {
        $('.js-list-right-slider.audio').slick({
          dots: true,
          arrows: false,
          autoplay: true,
          infinite: false,
          slidesToShow: 1,
          slidetToScroll: 1,
          autoplaySpeed: 8000,
          responsive: [{
              breakpoint: 1000,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 799,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            }
          ]
        });
      }

    }

  }

  if (articlesArr.length > 0) {
    articlesArr.map((item) => {
      let article = `
      <a href="${item.link}">
        <div class="image">
          ${item.image}
        </div>
        <div class="title">${item.name}</div>
      </a>`
      $('.right-col-list').append(article);
    })
  }

  let createRelatedPosts = function (item) {
    let itemLink = item.link;
    let itemName = item.name;
    let itemVertical = item.vertical.code;
    let itemVerticalName = item.vertical.name;
    let itemText = item.excerpt;

    let label = item.label ? `<span class="updated">${item.label}</span>` : '';

    return `
      <article>
        <a href="${itemLink}" role="link" title="${itemName}">
          <section class="label ${itemVertical}">${itemVerticalName}</section>
          ${label}
          <h3>${itemName}</h3>
          <p>${itemText}</p>
        </a>
      </article>
    `;
  };

};

let appendNextPosts = function (response, removeOld, wrapper = null) {
  let targetWrapper = wrapper;

  if (!targetWrapper || !targetWrapper.length) {
    targetWrapper = $('.js-article-list__wrapper, .js-organizace-list__wrapper').first();
  }

  if (!targetWrapper || !targetWrapper.length) {
    return [];
  }

  const loadMoreButton = targetWrapper.find('.js-load-more').first();
  const loadMoreContainer = loadMoreButton.closest('.article-list__wrapper_filter_more');

  if (removeOld) {
    targetWrapper.find('article, .form-item').remove();
  }

  if (response.show_more_button) {
    let href = response.show_more_button;

    // Pokud backend (REST) vrátí /wp-json/businessinfo/v1/list, přemapujeme href zpět na hezkou URL stránky.
    if (typeof href === 'string' && href.indexOf('/wp-json/businessinfo/v1/list') !== -1) {
      try {
        const urlObj = new URL(href, window.location.origin);
        const params = urlObj.searchParams;
        // Tyto parametry jsou jen pro REST vrstvy, na frontendu je nechceme v URL.
        params.delete('context');
        params.delete('vertical_id');
        const query = params.toString();
        href = window.location.pathname + (query ? '?' + query : '');
      } catch (e) {
        // Pokud parsování selže, použijeme původní href.
      }
    }

    loadMoreButton.attr('href', href);
    if (loadMoreContainer.length) {
      loadMoreContainer.removeClass('d-none');
    } else {
      loadMoreButton.show();
    }
  } else {
    if (loadMoreContainer.length) {
      loadMoreContainer.addClass('d-none');
    } else {
      loadMoreButton.hide();
    }
  }

  targetWrapper.children('.filter-result-info, .most-filtered, .filter-result-sorting').remove();
  $(response.status).insertAfter(targetWrapper.find('.loader-wrapper').first());

  let articleArr = response.postsList;
  let content = '';
  $.each(articleArr, function (key, item) {
    content += item;
  });

  const parsedNodes = $.parseHTML(content, document, true) || [];
  const contentNodes = parsedNodes.filter(node => node.nodeType === 1);

  // Default HP 4-col strip: REST homepage_feed returns raw article HTML (no
  // ads, those are SSR only), not 2-col .row pairs. Pack into the existing .row
  // so Task 5 flex still applies. Do not wrap each pair.
  if (targetWrapper.hasClass('article-list__wrapper_second--4col')) {
    let row = targetWrapper.children('.row').last();
    if (!row.length) {
      row = $('<div class="row"></div>');
      if (loadMoreContainer.length) {
        row.insertBefore(loadMoreContainer);
      } else if (loadMoreButton.length) {
        row.insertBefore(loadMoreButton);
      } else {
        targetWrapper.append(row);
      }
    }
    $(contentNodes).appendTo(row);
  } else if (loadMoreContainer.length) {
    $(contentNodes).insertBefore(loadMoreContainer);
  } else {
    $(contentNodes).insertBefore(loadMoreButton);
  }

  document.querySelectorAll('img[srcset]').forEach(img => {
    const controller = new AbortController();

    img.addEventListener('error', () => {
      controller.abort();
      img.srcset = img.dataset.fallbackSrcset || '';
    }, {
      signal: controller.signal,
      once: true
    });
  });

  return contentNodes;
};

/*let appendPrimaryPosts = function (response, removeOld) {
  console.log(response);
  if (removeOld) {
    $('.js-article-list__wrapper article, .js-article-list__wrapper .form-item').remove();
  }

  if (response.show_more_button) {
    $('.js-article-list__wrapper .js-load-more').attr('href', response.show_more_button).show();
  } else {
    $('.js-article-list__wrapper .js-load-more').hide();
  }

  $('.js-article-list__wrapper > .filter-result-info, .js-article-list__wrapper > .most-filtered, .js-article-list__wrapper > .filter-result-sorting').remove();
  $(response.status).insertAfter($('.js-article-list__wrapper .loader-wrapper'));

  let articleArr = response.posts;
  console.log(response.posts);

  $.each(articleArr, function (key, item) {

    let itemDate;
    let emptyArticle = "";

    if (item.vertical.code === 'events' || item.vertical.code === 'tenders') {
      itemDate = item.meta.date ? '<span class="date"><i class="fal fa-calendar-day"></i>' + item.meta.date + '</span>' : '';
    } else {
      itemDate = item.meta.date ? '<span class="date"><i class="fal fa-clock"></i>' + item.meta.date + '</span>' : '';
    }

    let itemType = item.meta.type ? '<span class="type"><i class="fal fa-tag"></i>' + item.meta.type + '</span>' : '';
    let itemPlace = item.meta.place ? '<span class="location"><i class="fal fa-map-marker-alt"></i>' + item.meta.place + '</span>' : '';

    let countries = [];

    $.each(item.meta.country, function (key, country) {
      countries.push(`<span class="country-item ${country.slug}"><img src='/wp-content/themes/businessinfo.cz.v2/dist/images/flags/${country.slug}.svg'> <span class="country-name">${country.name}</span></span>`)
    })

    let itemCountry = item.meta.country ? `<span class="country">${countries.join('')}</span>` : '';

    let label = item.label ? `<span class="label updated">${item.label}</span>` : '';

    if (item.meta.labels) {
      item.meta.labels.forEach((l) => {
        if (l == 'Velký týden malých firem') {
          label += `<span class="label velky-tyden-malych-firem"></span>`;
          emptyArticle = 'class="article-velky-tyden-malych-firem"';
        } else {
          label += `<span class="label source">Zdroj: <strong>${l}</strong></span>`;
        }
      })
    }

    if (item.excerpt == false && item.image == false) {
      emptyArticle = 'class="no-content"'
    }

    let temp;

    if (item.vertical.code === 'forms') {
      let documents = [];

      $.each(item.sources, function (key, doc) {
        documents.push(`<span class="label">${doc}</span>`);
      });

      temp = `
        <div class="form-item">
          <a href="${item.link}" role="link">
            <div class="title-wrapper">
              ${label}
              <h2>${item.name.replace('+', '<span class="plus">+<span>')}</h2>
            </div>
            <div class="form-info">
              <span class="institution">
                <i class="fal fa-university"></i>
                ${item.meta.institution}
                ${documents.join('')}
              </span>
            </div>
          </a>
        </div>
      `;
    } else {
      let articlePhoto = item.image ? `<div class="article-photo">${item.image}</div>` : '';

      temp = `
        <article ${emptyArticle}>
          <a href="${item.link}" role="link">
            <div class="title-wrapper">
              ${label}
              <h2>${item.name.replace('+', '<span class="plus">+<span>')}</h2>
            </div>
            <div class="article-info">
              ${itemDate}
              ${itemType}
              ${itemPlace}
              ${itemCountry}
            </div>
            ${articlePhoto}
            <div class="article-text">${item.excerpt}</div>
          </a>
        </article>
      `;
    }

    $(temp).insertBefore('.js-article-list__wrapper .js-load-more')
  })
};*/

let append404Posts = function (response, removeOld) {
  if (removeOld) {
    $('.error404__sidebar article').remove();
  }

  if (response.show_more_button) {
    $('.error404__sidebar .js-load-more').attr('href', response.show_more_button).show();
  } else {
    $('.error404__sidebar .js-load-more').hide();
  }

  let articleArr = response.posts;

  $.each(articleArr, function (key, item) {
    var itemDate;
    if (item.vertical.code === 'events' || item.vertical.code === 'tenders') {
      itemDate = item.meta.date ? '<span class="date"><i class="fal fa-calendar-day"></i>&nbsp;' + item.meta.date + '</span>' : '';
    } else {
      itemDate = item.meta.date ? '<span class="date"><i class="fal fa-clock"></i>&nbsp;' + item.meta.date + '</span>' : '';
    }
    let itemImage = item.image ? '<div class="img">' + item.image + '</div>' : '';
    let temp;

    temp = `
        <article>
          <a href="${item.link}">
          ${itemImage}
          <div class="title">
            ${item.name}
            ${itemDate}
          </div>
          </a>
        </article>
      </section>
    `;

    $('.error404__sidebar .recommended .recommended-articles').append($(temp));
  })
};

/* TODO: asi staré, nenašel jsem že by se používalo. */
let appendRelatedPosts = function (response, tab) {

  if (response.by_categories.show_more_button) {
    $('.related-content-column .more').attr('href', response.by_categories.show_more_button);
  } else {
    $('.related-content-column .more').remove();
  }

  $.each(response.by_categories.posts, function (key, item) {
    let label = item.label ? `<span class="updated">${item.label}</span>` : '';

    const temp = `
      <article>
        <a href="${item.link}" role="link" title="${item.name}">
          <section class="label ${item.vertical.code}">${item.vertical.name}</section>
          ${label}
          <h3>${item.name}</h3>
          <p>${item.excerpt}</p>
        </a>
      </article>
    `;

    $(temp).insertBefore($('.related-content__wrapper .more'));
  })
};

let renderSimilarContent = function (response) {
  let similarArr = response.posts;

  $.each(similarArr, function (key, item) {
    let detail;

    if (item.vertical.code == 'tenders') {

      let countries = [];
      $.each(item.meta.country, function (key, country) {
        countries.push(country.name);
      })

      detail = `
        <div class="tender-detail">
          <span>Platnost nabídky do <strong>${item.meta.date}</strong></span>
          <span>${countries.join(', ')}</span>
        </div>
      `;
    } else if (item.vertical.code == 'events') {
      detail = `
      <div class="event-detail">
        <span><strong>${item.meta.date}</strong></span>
        <span>${item.meta.type}</span>
      </div>
      `;
    } else if (item.vertical.code == 'forms') {
      detail = `
      <div class="form-detail">
        <span>${item.meta.institution}</span>
        <span>Dokument: ${item.sources.join(' / ')}</span>
      </div>
      `;
    } else {
      detail = ``;
    }

    let temp = `
    <article>
      <a href="${item.link}" role="link">
        <div class="image-wrapper">
            ${item.image}
        </div>

        <span class="topic">${item.vertical.name}</span>
        <h4>${item.name}</h4>
        <div class="text">${item.excerpt}</div>
        ${detail}
      </a>
    </article>
    `;

    $('.related-articles__wrapper').append(temp);
  })
};

$(document).ready(function () {
  $.cachedScript('https://cdn.jsdelivr.net/gh/yeikos/jquery.history/jquery.history.js').done(function () {
    $.history.on('load change push pushed').listen();
  });

  $.cachedScript('https://cdn.jsdelivr.net/npm/jquery-query-object@2.2.3/jquery.query-object.min.js').done(function () {
    if ($('body').hasClass('error404')) {
      $.get($.query.parseNew(location.search).set('ajax-snippet', 'search').toString()).fail(function (data) {
        let errorContainer = $('main.error404');

        if ($.trim(data.responseText)) {
          errorContainer.find('.error404__sidebar').removeClass('loading').append(data.responseText);
        } else {
          errorContainer.removeClass('article-list').addClass('full');
          errorContainer.find('.error404__sidebar').remove()
        }
      });
    }

    // Až po načtení jquery-query-object (poskytuje $.query.parseNew) — jinak padá loadRelatedContent na archivech bez REST URL.
    // Na detailu kvízu odložíme related-content mimo kritickou cestu startu kvízu.
    const scheduleRelatedContentLoad = function () {
      const isQuizSingle = document.body.classList.contains('single-bi_quiz');
      if (!isQuizSingle) {
        loadRelatedContent();
        return;
      }

      let loaded = false;
      const run = function () {
        if (loaded) return;
        loaded = true;
        loadRelatedContent();
      };

      // 1) Když je pravý sloupec brzy in-view, načti hned.
      if ('IntersectionObserver' in window) {
        const target = document.querySelector('.article-right-column');
        if (target) {
          const observer = new IntersectionObserver(function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) {
              observer.disconnect();
              run();
            }
          }, { rootMargin: '200px 0px' });
          observer.observe(target);
        }
      }

      // 2) Idle fallback (nebo timeout), aby se nenačítalo příliš pozdě.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 1500 });
      } else {
        setTimeout(run, 800);
      }
    };
    scheduleRelatedContentLoad();

    loadMore();
    loadFilter();
    loadSimilarContent();
    loadRightWidgetContent();
    lazyLoadSnippets();
    formSecondList();
  });
});

// řeší při výpisu formulařů, ve výpisu verticali, aby tlacitka ke stažení dokumentu, byly zarovnany v každém boxu, od shora smerem dolu.
let formSecondList = function () {
  if (document.body.getAttribute('data-cpt') !== 'forms') return;

  $('.js-article-list__wrapper .row').each(function () {
    // Skip non-article siblings (SSR .hp-ad-frame on default HP) so they do
    // not participate in height packing. Do not assume 2-col .row wrappers.
    const articles = $(this).children('article');
    let heights = [];
    articles.each(function () {
      const otherInfo = $(this).find('.article-other-info');
      if (otherInfo.length) {
        otherInfo.css('min-height', '');
        heights.push(otherInfo.outerHeight());
      } else {
        heights.push(0);
      }
    });
    if (heights.length) {
      heights.sort((a, b) => b - a);
    }
    articles.each(function () {
      const otherInfo = $(this).find('.article-other-info');
      if (otherInfo.length) {
        otherInfo.css('min-height', heights[0]);
      }
    });
    heights = null;
  });
};

let focusFirstInsertedArticleLink = function (insertedRoots) {
  if (!insertedRoots || !insertedRoots.length) {
    return;
  }

  let focusLink = null;
  for (let i = 0; i < insertedRoots.length; i += 1) {
    const root = insertedRoots[i];
    if (!root || root.nodeType !== 1) {
      continue;
    }
    if (root.nodeName === 'ARTICLE') {
      focusLink = root.querySelector('a[href]');
      if (focusLink) {
        break;
      }
    }
    const innerArticle = root.querySelector && root.querySelector('article');
    if (innerArticle) {
      focusLink = innerArticle.querySelector('a[href]');
      if (focusLink) {
        break;
      }
    }
  }
  if (focusLink && typeof focusLink.focus === 'function') {
    window.requestAnimationFrame(function () {
      try {
        focusLink.focus({ preventScroll: true });
      } catch (err) {
        focusLink.focus();
      }
    });
  }
};

let formSecondListBodyResize = function (func, wait) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(func, wait);
  };
};

window.addEventListener('resize', formSecondListBodyResize(formSecondList, 150));

// pri kliku na tlacito zobrazit více
let loadMore = function () {
  const params = new URLSearchParams(window.location.search);
  const ord = params.get('ord');
  const sort = params.get('sort');

  if (sort === 'title') {
    $('.js-organizace-az, .js-organizace-za').removeClass('active');
    if (ord === 'asc') {
      $('.js-organizace-az').addClass('active');
    } else if (ord === 'desc') {
      $('.js-organizace-za').addClass('active');
    }
  }

  $('body').on('click', '.js-organizace-az, .js-organizace-za', function (e) {
    e.preventDefault();

    const params = new URLSearchParams(window.location.search);
    const isAsc = $(this).hasClass('js-organizace-az');

    params.set('sort', 'title');
    params.set('ord', isAsc ? 'asc' : 'desc');
    // po změně řazení vždy začínáme od první stránky
    params.delete('pg');

    const query = params.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  });

  $('body').on('keydown', '.js-article-list__wrapper .js-load-more[role="button"], .js-organizace-list__wrapper .js-load-more[role="button"]', function (e) {
    if (e.key !== ' ') {
      return;
    }
    e.preventDefault();
    this.click();
  });

  $('body').on('click', '.js-article-list__wrapper .js-load-more, .js-organizace-list__wrapper .js-load-more', function (e) {
    e.preventDefault();

    let button = $(this);
    let wrapper = button.closest('.js-article-list__wrapper, .js-organizace-list__wrapper');

    let href = button.attr('href');
    let requestUrl;

    const listCtx = window.biListContext || window.biFilterContext;
    if (typeof window.biRestListUrl !== 'undefined' && typeof listCtx !== 'undefined' && href.indexOf('wp-json') === -1) {
      const queryPart = href.indexOf('?') !== -1 ? href.substring(href.indexOf('?') + 1) : '';
      const ctx = listCtx;
      requestUrl = window.biRestListUrl + '?' + queryPart + (queryPart ? '&' : '') + 'context=' + ctx.context + (ctx.vertical_id ? '&vertical_id=' + ctx.vertical_id : '');
    } else if (href.indexOf('wp-json') !== -1) {
      requestUrl = href;
    } else {
      let query = $.query.parseNew(href.split('?').length > 1 ? href.split('?')[1] : '');
      query = query.set('ajax', 1);
      requestUrl = query.toString();
    }

    button.addClass('is-loading');
    wrapper.attr('aria-busy', 'true');

    const clearLoadMoreBusy = function () {
      button.removeClass('is-loading');
      wrapper.attr('aria-busy', 'false');
    };

    biGetJSON(requestUrl, function (response) {

      if (typeof $.history === 'function') {
        $.history.push(href);
      }

      let scrollPosition = $(window).scrollTop();
      const insertedRoots = appendNextPosts(response, false, wrapper);

      clearLoadMoreBusy();

      $(document).scrollTop(scrollPosition);
      initTooltips();
      formSecondList();
      if (typeof window.highlightArticlesByRegion === 'function') {
        window.highlightArticlesByRegion();
      }

      const shouldFocusNewCards = wrapper.hasClass('js-organizace-list__wrapper')
        || wrapper.hasClass('article-list__wrapper_second--4col');
      if (shouldFocusNewCards) {
        focusFirstInsertedArticleLink(insertedRoots);
      }
    }, function () {
      clearLoadMoreBusy();
    });
  });

  $('body').on('click', '.error404__sidebar .more', function (e) {
    e.preventDefault();

    let button = $(this);

    let url = button.attr('href');
    let query = $.query.parseNew(url.split("?").length > 1 ? url.split("?")[1] : "");
    query = query.set('ajax', 1);

    button.addClass('is-loading');

    biGetJSON(query.toString(), function () {}, function (response) {
      if (typeof $.history === 'function') {
        $.history.push(url);
      }

      let scrollPosition = $(window).scrollTop();

      append404Posts(response.responseJSON, false);

      button.removeClass('is-loading');

      $(document).scrollTop(scrollPosition);
    });
  });

  $('body').on('click', '.related-content-column .more', function (e) {
    e.preventDefault();

    let button = $(this);
    let tab = $(this).parent().attr('id');
    let url = button.attr('href');
    let query = $.query.parseNew(url.split("?").length > 1 ? url.split("?")[1] : "");
    query = query.set('ajax', 1).set('load', 'related-content');

    button.addClass('is-loading');

    biGetJSON(query.toString(), function (response) {
      let scrollPosition = $(window).scrollTop();

      appendRelatedPosts(response, tab);

      button.removeClass('is-loading');
      $(document).scrollTop(scrollPosition);
    });

  });
  $('body').on('click', '.gx-right-widget .more-articles .more', function (e) {
    e.preventDefault();
    let button = $(this);
    let href = button.attr('href');
    let requestUrl;
    if (typeof window.biRestRightWidgetUrl !== 'undefined' && typeof window.biRelatedContentPostId !== 'undefined' && href.indexOf('wp-json') === -1) {
      let queryPart = href.indexOf('?') !== -1 ? href.substring(href.indexOf('?') + 1) : '';
      requestUrl = window.biRestRightWidgetUrl + '?post_id=' + encodeURIComponent(window.biRelatedContentPostId) + (queryPart ? '&' + queryPart : '');
    } else if (href.indexOf('wp-json') !== -1) {
      requestUrl = href;
    } else {
      let query = $.query.parseNew(href.split('?').length > 1 ? href.split('?')[1] : '');
      query = query.set('ajax', 1).set('load', 'right-widget');
      requestUrl = query.toString();
    }
    button.addClass('is-loading');

    biGetJSON(requestUrl, function (response) {
      let scrollPosition = $(window).scrollTop();
      appendRightWidgetPosts(response);
      button.removeClass('is-loading');
      $(document).scrollTop(scrollPosition);
    });
  });

  const biFocusOrganizaceSeznamPoRazeni = function () {
    const params = new URLSearchParams(window.location.search);
    const sort = params.get('sort');
    const ord = params.get('ord');
    if (sort !== 'title' || (ord !== 'asc' && ord !== 'desc')) {
      return;
    }
    const wrapper = document.querySelector('.js-organizace-list__wrapper');
    const firstArticle = wrapper && wrapper.querySelector('article');
    const firstLink = firstArticle && firstArticle.querySelector('a[href]');
    if (!firstLink || typeof firstLink.focus !== 'function') {
      return;
    }
    window.requestAnimationFrame(function () {
      try {
        firstLink.focus({ preventScroll: true });
      } catch (e) {
        firstLink.focus();
      }
    });
  };
  biFocusOrganizaceSeznamPoRazeni();
};

let loadRelatedContent = function (refresh, query) {
  let rightColumn;
  rightColumn = $('.article-right-column');
  if (rightColumn.length) {
    // Data vložená v HTML při prvním renderu – žádný síťový request
    if (typeof window.__BI_RELATED_CONTENT__ !== 'undefined') {
      renderRelatedContent(window.__BI_RELATED_CONTENT__);
      $('.article-right-column').removeClass('is-loading');
      delete window.__BI_RELATED_CONTENT__;
      return;
    }
    let url;
    if (typeof window.biRelatedContentRestUrl !== 'undefined') {
      // Nový REST endpoint: s post_id pro single, bez post_id (nebo post_id=0) pro vyhledávání/úvodní bez příspěvku
      var postId = typeof window.biRelatedContentPostId !== 'undefined' ? window.biRelatedContentPostId : 0;
      url = window.biRelatedContentRestUrl + (postId > 0 ? '?post_id=' + encodeURIComponent(postId) : '');
    } else {
      if (!query) {
        query = $.query.parseNew(location.search);
      }
      query = query.set('ajax', 1).set('load', 'related-content');
      url = query.toString();
    }
    biGetJSON(
      url,
      function (response) {
        renderRelatedContent(response);
        $('.article-right-column').removeClass('is-loading');
      },
      function () {
        $('.article-right-column').removeClass('is-loading');
      }
    );
  }
};

let loadRightWidgetContent = function () {
  let widget = $('.gx-right-widget');
  if (widget.length) {
    let url;
    if (typeof window.biRestRightWidgetUrl !== 'undefined' && typeof window.biRelatedContentPostId !== 'undefined') {
      url = window.biRestRightWidgetUrl + '?post_id=' + encodeURIComponent(window.biRelatedContentPostId);
    } else {
      let query = $.query.parseNew(location.search);
      query = query.set('ajax', 1).set('load', 'right-widget');
      url = query.toString();
    }
    biGetJSON(url, function (response) {
      renderRightWidgetContent(response);
    });
  }
};

let renderRightWidgetContent = function (response) {
  let postsArr;

  let createPosts = function (post) {
    return `
    <a href="${post.link}" role="link" class="article-link">
      <div class="image">
      ${post.image}
      </div>
      <div class="text-content">
        <div class="title">${post.name}</div>
        <div class="text">${post.excerpt}</div>
      </div>
    </a>
    `;
  }

  if (response && response.posts && typeof response.posts === 'object' && response.posts.items && Array.isArray(response.posts.items) && response.posts.items.length > 0) {
    postsArr = response.posts.items;
    let postContainer = `
    <div class="block articles">
      <h5>${response.posts.title}</h5>
      <div class="article-links"></div>
    </div>
    `;
    $('.gx-right-widget').append(postContainer);

    $.each(postsArr, function (key, post) {
      $('.gx-right-widget .block.articles .article-links').append(createPosts(post));
    });
  }
};


let appendRightWidgetPosts = function (response) {

  if (response.posts.show_more_button) {
    $('.gx-right-widget .more-articles .more').attr('href', response.posts.show_more_button);
  } else {
    $('.gx-right-widget .more-articles .more').remove();
  }

  $.each(response.posts.items, function (key, post) {

    const temp = `
    <a href="${post.link}" role="link" class="article-link">
      <div class="image">
      ${post.image}
      </div>
      <div class="text-content">
        <div class="title">${post.name}</div>
        <div class="text">${post.excerpt}</div>
      </div>
    </a>
    `;

    $(temp).insertBefore($('.gx-right-widget .more-articles'));
  })
};

let loadSimilarContent = function () {
  let related = $('.related-articles__wrapper');

  if (related.length) {
    let url;
    if (typeof window.biRestSimilarContentUrl !== 'undefined' && typeof window.biRelatedContentPostId !== 'undefined') {
      url = window.biRestSimilarContentUrl + '?post_id=' + encodeURIComponent(window.biRelatedContentPostId);
    } else {
      let query = $.query.parseNew(location.search);
      query = query.set('ajax', 1).set('load', 'similar-content');
      url = query.toString();
    }
    biGetJSON(url, function (response) {
      renderSimilarContent(response);
    });
  }
};

let lazyLoadSnippets = function () {
  $('div[data-ajax]').bind('ajax:init', function (e, search, callback) {
    let target = $(this);
    let ajaxType = target.data('ajax');

    if (ajaxType === 'custom-posts' && typeof window.biRestCustomPostsUrl !== 'undefined' && typeof window.biRelatedContentPostId !== 'undefined') {
      let params = target.data('params') || '';
      let index = 1;
      if (params.indexOf('index=') !== -1) {
        index = parseInt(params.split('index=')[1], 10) || 1;
      }
      let contentPage =
        typeof window.biRelatedContentPage !== 'undefined' ? window.biRelatedContentPage : 1;
      let url =
        window.biRestCustomPostsUrl +
        '?post_id=' +
        encodeURIComponent(window.biRelatedContentPostId) +
        '&index=' +
        index +
        '&content_page=' +
        encodeURIComponent(contentPage);
      biGetHTML(url, function (result) {
        if ($.isFunction(callback)) {
          callback(result);
        } else if (result) {
          target.html(result);
          if (!target.find('article').length) {
            target.remove();
          }
        } else if (target.data('remove-empty')) {
          target.remove();
        }
      });
      return;
    }

    let query = $.query.parseNew(search ? search : (target.data('params') ? target.data('params') : location.search));
    query = query.set('ajax', ajaxType);

    $.get(query.toString(), function (result) {
      if ($.isFunction(callback)) {
        callback(result);
      } else if (result) {
        target.html(result);

        if (ajaxType === 'custom-posts' && !target.find('article').length) {
          target.remove();
        }
      } else if (target.data('remove-empty')) {
        target.remove();
      }
    });
  });

  $('div[data-ajax]').each(function () {
    $(this).trigger('ajax:init');
  });

  $('body').on('click', '.custom-posts[data-ajax] a.page-numbers', function (e) {
    e.preventDefault();

    let container = $(this).parents('.custom-posts[data-ajax]');
    let dest = $(this).prop('href');

    $(this).addClass('is-loading');

    if (typeof window.biRestCustomPostsUrl !== 'undefined' && typeof window.biRelatedContentPostId !== 'undefined' && dest.indexOf('wp-json') === -1) {
      let params = container.data('params') || '';
      let index = 1;
      if (params.indexOf('index=') !== -1) {
        index = parseInt(params.split('index=')[1], 10) || 1;
      }
      let page = 1;
      try {
        let urlObj = new URL(dest, window.location.origin);
        let p =
          urlObj.searchParams.get('custom-posts-page') ||
          urlObj.searchParams.get('page') ||
          urlObj.searchParams.get('paged');
        if (p) page = parseInt(p, 10) || 1;
      } catch (err) {}
      let contentPage =
        typeof window.biRelatedContentPage !== 'undefined' ? window.biRelatedContentPage : 1;
      let url =
        window.biRestCustomPostsUrl +
        '?post_id=' +
        encodeURIComponent(window.biRelatedContentPostId) +
        '&index=' +
        index +
        '&page=' +
        page +
        '&content_page=' +
        encodeURIComponent(contentPage);
      biGetHTML(url, function (result) {
        if (result) {
          container.html(result);
          $('html, body').animate({ scrollTop: container.offset().top - 100 }, 400);
        }
        container.find('a.page-numbers').removeClass('is-loading');
      });
    } else {
      biGetHTML(dest, function (result) {
        if (result) {
          container.html(result);
          $('html, body').animate({ scrollTop: container.offset().top - 100 }, 400);
        }
        container.find('a.page-numbers').removeClass('is-loading');
      });
    }
  });
};

jQuery.cachedScript = function (url, options) {
  options = $.extend(options || {}, {
    dataType: "script",
    cache: true,
    url: url
  });

  return jQuery.ajax(options);
};

$('body').on('click', '.hp-video-slider .hp-video-slider-item > a, .right-col-video-slider .right-col-slider-item > a, .podnikatelky-multibox__videos .right-col-slider-item > a', function (e) {
  if (!window.cookieConsent || !window.cookieConsent.allowedCategory('third_party')) {
    e.preventDefault();
    e.stopPropagation();
    var $a = $(this);
    var fallback = $a.attr('data-fallback-href');
    var url = (fallback && String(fallback).length) ? fallback : $a.prop('href');
    window.open(url, '_blank');
  }
})
